import React, { createContext, useContext, useState, useMemo } from 'react';

const CommunitySearchContext = createContext();

export const useCommunitySearch = () => {
    const context = useContext(CommunitySearchContext);
    if (!context) {
        throw new Error('useCommunitySearch must be used within a CommunitySearchProvider');
    }
    return context;
};

export const CommunitySearchProvider = ({ children }) => {
    const [searchTerm, setSearchTerm] = useState("");

    const value = useMemo(() => ({
        searchTerm,
        setSearchTerm
    }), [searchTerm]);

    return (
        <CommunitySearchContext.Provider value={value}>
            {children}
        </CommunitySearchContext.Provider>
    );
};

